"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
document.addEventListener('alpine:init', function () {
    var emailRegex = /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/i;
    Alpine.data('footer', function () {
        return {
            submitted: false,
            loading: false,
            success: false,
            errors: {
                server: '', // Errors from server.
                name: '',
                email: '',
            },
            inputs: {
                name: '',
                email: '',
                turnstileToken: '',
            },
            submit: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        this.submitted = true;
                        this.success = false;
                        this.errors.server = '';
                        if (!this.validate()) {
                            // Focus on the first invalid field.
                            this.$nextTick(function () {
                                _this.$refs.newsletterSignupForm.querySelector('input.wpforms-error').focus();
                            });
                        }
                        else {
                            this.loading = true;
                            this.$store.app.loadTurnstile('#turnstile-newsletter', 'newsletter', function (turnstileToken, callbackMethod) { return __awaiter(_this, void 0, void 0, function () {
                                var response;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // console.group('Turnstile response')
                                            // console.log('TOKEN: ', turnstileToken || 'N/A');
                                            // console.log('CALLBACK METHOD:', callbackMethod);
                                            // console.groupEnd();
                                            if (callbackMethod === types_1.TurnstileMethods.BEFORE_INTERACTIVE) {
                                                this.loading = false;
                                                return [2 /*return*/, false];
                                            }
                                            if (!(turnstileToken && callbackMethod === types_1.TurnstileMethods.HAS_TOKEN)) return [3 /*break*/, 2];
                                            // Add the token to the fields we're sending to the backend.
                                            this.inputs.turnstileToken = turnstileToken;
                                            this.loading = true;
                                            return [4 /*yield*/, this.sendRequest()];
                                        case 1:
                                            response = _a.sent();
                                            this.loading = false;
                                            if (response.success) {
                                                this.success = true;
                                                this.track();
                                            }
                                            else {
                                                this.errors.server = response.message;
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.loading = false;
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [2 /*return*/];
                    });
                });
            },
            validate: function () {
                var valid = true;
                // Reset errors.
                this.errors.name = '';
                this.errors.email = '';
                if (this.inputs.name.length < 3) {
                    this.errors.name = 'Please enter your full name.';
                    valid = false;
                }
                if (!emailRegex.test(this.inputs.email)) {
                    this.errors.email = 'Please enter a valid email address.';
                    valid = false;
                }
                return valid;
            },
            track: function () {
                this.$store.app.track({
                    event: 'form_submit',
                    form_variant: 'footer',
                    form_name: 'newsletter-subscribe',
                });
            },
            sendRequest: function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.$store.app.api('newsletter', this.inputs)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            },
        };
    });
});
